import { Link } from 'react-router-dom';

const articles = [
  {
    tag: 'Guida',
    tagClass: 'bg-primary-100 text-primary-700',
    title: 'Itaobuy Spreadsheet Italia 2026: La guida completa che tutti i principianti devono conoscere',
    link: '/articolo/guida-completa-itaobuy-spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20displaying%20organized%20product%20grid%20on%20light%20cream%20desk%20natural%20daylight%20warm%20neutral%20tones%20clean%20editorial%20photography%20european%20style%20organized%20aesthetic%20with%20notebook%20and%20coffee%20cup%20on%20side&width=700&height=470&seq=artgrid-guide-2026&orientation=landscape',
  },
  {
    tag: 'Tutorial',
    tagClass: 'bg-secondary-100 text-secondary-700',
    title: 'Come usare Itaobuy Spreadsheet nel 2026: guida passo passo per principianti',
    link: '/articolo/come-usare-itaobuy-spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20setup%20with%20laptop%20showing%20numbered%20instructions%20on%20screen%20clean%20cream%20desk%20surface%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20learning%20workspace%20with%20sticky%20notes%20arranged&width=700&height=470&seq=artgrid-tutorial-2026&orientation=landscape',
  },
  {
    tag: 'Sicurezza',
    tagClass: 'bg-accent-100 text-accent-700',
    title: 'Itaobuy e sicuro? 7 controlli essenziali prima di acquistare online',
    link: '/articolo/itaobuy-spreadsheet-sicurezza',
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20concept%20with%20laptop%20displaying%20safety%20checklist%20on%20light%20cream%20desk%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20trust%20protection%20visual%20with%20lock%20icon%20floating&width=700&height=470&seq=artgrid-safety-2026&orientation=landscape',
  },
  {
    tag: 'Confronto',
    tagClass: 'bg-primary-100 text-primary-700',
    title: 'Itaobuy Spreadsheet vs Alternative: Quale metodo conviene davvero?',
    link: '/articolo/itaobuy-spreadsheet-confronto',
    image: 'https://readdy.ai/api/search-image?query=Two%20laptop%20screens%20side%20by%20side%20on%20light%20cream%20desk%20one%20showing%20organized%20grid%20the%20other%20chaotic%20browser%20tabs%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20split%20comparison%20concept&width=700&height=470&seq=artgrid-compare-2026&orientation=landscape',
  },
  {
    tag: 'Categorie',
    tagClass: 'bg-secondary-100 text-secondary-700',
    title: '10 migliori categorie Itaobuy Spreadsheet da conoscere nel 2026',
    link: '/articolo/itaobuy-spreadsheet-categorie',
    image: 'https://readdy.ai/api/search-image?query=Grid%20of%20diverse%20product%20category%20icons%20arranged%20neatly%20on%20light%20cream%20surface%20shoes%20clothing%20bags%20accessories%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20organized%20catalog%20layout&width=700&height=470&seq=artgrid-categories-2026&orientation=landscape',
  },
  {
    tag: 'Vantaggi',
    tagClass: 'bg-accent-100 text-accent-700',
    title: '5 vantaggi di Itaobuy Spreadsheet che ogni acquirente dovrebbe conoscere',
    link: '/articolo/itaobuy-spreadsheet-vantaggi',
    image: 'https://readdy.ai/api/search-image?query=Happy%20person%20browsing%20organized%20product%20list%20on%20laptop%20in%20bright%20modern%20room%20with%20natural%20daylight%20cream%20walls%20clean%20desk%20with%20coffee%20minimalist%20editorial%20lifestyle%20photography%20european%20style%20satisfied%20shopping%20experience&width=700&height=470&seq=artgrid-benefits-2026&orientation=landscape',
  },
  {
    tag: 'Guida',
    tagClass: 'bg-primary-100 text-primary-700',
    title: 'Itaobuy Spreadsheet per principianti: tutto quello che devi sapere per iniziare',
    link: '/articolo/come-usare-itaobuy-spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20friendly%20workspace%20setup%20with%20simple%20laptop%20showing%20welcome%20screen%20on%20light%20cream%20desk%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20easy%20start%20concept%20with%20fresh%20coffee%20nearby&width=700&height=470&seq=artgrid-beginners-2026&orientation=landscape',
  },
  {
    tag: 'Shopping',
    tagClass: 'bg-secondary-100 text-secondary-700',
    title: 'Shopping intelligente con Itaobuy Spreadsheet: strategie per acquisti migliori',
    link: '/articolo/itaobuy-spreadsheet-confronto',
    image: 'https://readdy.ai/api/search-image?query=Smart%20shopping%20concept%20with%20laptop%20showing%20price%20comparison%20chart%20on%20light%20cream%20desk%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20intelligent%20consumer%20with%20calculator%20and%20product%20images&width=700&height=470&seq=artgrid-smartshop-2026&orientation=landscape',
  },
  {
    tag: 'Organizzazione',
    tagClass: 'bg-accent-100 text-accent-700',
    title: 'Come organizzare la tua ricerca prodotti con Itaobuy Spreadsheet',
    link: '/articolo/itaobuy-spreadsheet-categorie',
    image: 'https://readdy.ai/api/search-image?query=Organized%20desk%20setup%20with%20color%20coded%20folders%20and%20laptop%20showing%20structured%20product%20list%20on%20light%20cream%20surface%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20systematic%20approach%20to%20product%20discovery&width=700&height=470&seq=artgrid-organize-2026&orientation=landscape',
  },
  {
    tag: 'Sicurezza',
    tagClass: 'bg-primary-100 text-primary-700',
    title: 'Errori da evitare quando usi Itaobuy Spreadsheet: guida alla sicurezza',
    link: '/articolo/itaobuy-spreadsheet-sicurezza',
    image: 'https://readdy.ai/api/search-image?query=Warning%20sign%20concept%20with%20laptop%20showing%20security%20alert%20on%20light%20cream%20desk%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20caution%20theme%20with%20checklist%20document%20nearby%20for%20safe%20browsing&width=700&height=470&seq=artgrid-errors-2026&orientation=landscape',
  },
  {
    tag: 'Consigli',
    tagClass: 'bg-secondary-100 text-secondary-700',
    title: 'Acquistare meglio con Itaobuy Spreadsheet: i consigli degli esperti italiani',
    link: '/articolo/itaobuy-spreadsheet-vantaggi',
    image: 'https://readdy.ai/api/search-image?query=Expert%20consultant%20hand%20pointing%20at%20laptop%20screen%20showing%20product%20details%20on%20light%20cream%20desk%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20professional%20advice%20concept%20with%20notes%20and%20product%20comparisons%20visible&width=700&height=470&seq=artgrid-experts-2026&orientation=landscape',
  },
  {
    tag: 'Novita',
    tagClass: 'bg-accent-100 text-accent-700',
    title: 'Itaobuy Spreadsheet 2026: tutte le novita e gli aggiornamenti di quest\'anno',
    link: '/articolo/guida-completa-itaobuy-spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=New%20year%20calendar%20and%20laptop%20showing%20fresh%20updated%20product%20list%20on%20light%20cream%20desk%20soft%20natural%20daylight%20minimalist%20editorial%20warm%20neutral%20tones%20european%20style%20fresh%20start%20concept%20with%202026%20marker%20and%20organized%20workspace&width=700&height=470&seq=artgrid-news-2026&orientation=landscape',
  },
];

export default function ArticleGrid() {
  return (
    <section id="articoli" className="py-16 md:py-24 px-6 md:px-10 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-4">
              Guide &amp; Tutorial
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              Risorse per imparare e acquistare meglio
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-lg">
            Guide complete, tutorial passo passo e consigli sulla sicurezza per utilizzare al meglio Itaobuy Spreadsheet. Ogni risorsa e pensata per il pubblico italiano.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {articles.map((article, idx) => (
            <Link
              key={idx}
              to={article.link}
              className="group bg-white rounded-2xl border border-background-200/70 overflow-hidden hover:border-background-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.image}
                  alt={`${article.tag} Itaobuy Spreadsheet`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-semibold tracking-wide mb-2 ${article.tagClass}`}>
                  {article.tag}
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-3">
                  {article.title}
                </h3>
                <div className="flex items-center gap-1.5 mt-3 text-primary-600 text-xs font-medium">
                  <span>Leggi l&apos;articolo</span>
                  <i className="ri-arrow-right-line text-xs w-3.5 h-3.5 flex items-center justify-center"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-foreground-400 text-sm mb-4">
            Stiamo preparando altre guide SEO. Torna presto per nuovi contenuti in italiano su Itaobuy Spreadsheet.
          </p>
        </div>
      </div>
    </section>
  );
}